import { Button } from '@chakra-ui/react';

const ButtonLink = ({ onClick, color = 'var(--color-primary70)', height, width, children, ...props }) => (
  <Button variant={'link'} onClick={onClick} color={color} height={height} width={width} {...props}>
    {children}
  </Button>
);

export default ButtonLink;
